export default __webpack_public_path__ + "media/nuxtjs.6de3ceb6.png";